import React from 'react';
import { isImageProxyTemplate, formatImageProxyUrl, formatUrl } from '../../utils/svtimage';
import { StyledCircleLink, Link, Figure, RelatedTitle, RelatedTitleSpan } from './CircleLink.styles';
import PlayImage from '../PlayImage/PlayImage';
import { TYPES } from '../typography/PlayText/PlayText';

const CircleLink = ({ name, slug, thumbnailImage, imageAltText, index, onClick, forwardedRef }) => {
    let thumbnail;

    if (isImageProxyTemplate(thumbnailImage)) {
        thumbnail = formatImageProxyUrl(thumbnailImage, 'square', 200);
    } else {
        thumbnail = formatUrl(thumbnailImage, 'square');
    }

    return (
        <StyledCircleLink data-rt="related-genre" ref={forwardedRef}>
            <Link to={`/genre/${slug}`} className={`lp_pos${index}`} onAfterClick={onClick}>
                <Figure>
                    <PlayImage imageRatio="square" src={thumbnail} alt={imageAltText} />
                </Figure>
                <RelatedTitle>
                    <RelatedTitleSpan type={TYPES.LARGE}>{name}</RelatedTitleSpan>
                </RelatedTitle>
            </Link>
        </StyledCircleLink>
    );
};

export default React.memo(CircleLink);
